<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="the-face-of-god">
<h1>The Face Of God</h1>
<p style="text-indent: 4em; text-align: center;">Kismet? (Praise Him) Allah?</p>
<p style="text-align: center;">The caterer’s boy gets a look</p>
<p style="text-indent: 4em; text-align: center;">At Iblissa nude in her spa.</p>
<p style="text-align: center;">Naturally, he’s hooked</p>
<br/>
<p style="text-align: center;">And sleepless out of spite For everything beyond his grasp.</p>
<p style="text-align: center;">So he moonlights at open mics Putting the Qur’an to rap</p><br/>
<p style="text-align: center;">Profane, derisible,</p>
<p style="text-align: center;">Free-styled, by his heart’s mad dancing:</p>
<p style="text-align: center;"><em>The Tongue of the Invisible</em></p>
<p style="text-align: center;">He calls his hip-hop trances.</p><br/>
<p style="text-align: center;">One gig he’s overwhelmed By Homeland Feds and arrested</p>
<p style="text-align: center;">For coding plots to sleeper cells.</p>
<p style="text-align: center;">Without counsel, questioned</p><br/>
<p style="text-align: center;">Non-stop for forty nights, Broken down, he hallucinates</p>
<p style="text-align: center;">That they’re offering Paradise If he will cooperate.</p><br/>
<p style="text-align: center;">So he frames Iblissa, Gives her up as foreign agent</p>
<p style="text-align: center;">Of her imam who launders his Covert aid to insurgents.</p>
<br/>
<p style="text-align: center;">As Feds trace the assets, They position the rat rapper</p>
<p style="text-align: center;">Undercover to capture facets Of what’s about to happen:</p><br/>
<p style="text-align: center;">New pool boy now to lurk By the zemzem she sanctifies.</p>
<p style="text-align: center;">Wired under his Hawaiian shirt, His Speedo rank and defiled,</p><br/>
<p style="text-align: center;">Desire flickers. Sunlight Glimmers off the hoop of the skimmer.</p>
<p style="text-align: center;">Winking blind, he finds her lying Oiled to a lustrous shimmer</p><br/>
<p style="text-align: center;">In a string bikini—</p>
<p style="text-align: center;">Triangles clasped to moist bronzed flesh.</p>
<p style="text-align: center;">And she whispers, “Want what you see?” Is it a taunt or a test?</p><br/>
<p style="text-align: center;">He thinks he wants the truth.</p>
<p style="text-align: center;">But freedom too. No. Her body.</p>
<p style="text-align: center;">Her wealth. No. The greatest beauty.</p>
<p style="text-align: center;">He cries, “I want to see God!”</p><br/>
<p style="text-align: center;">“Then take up the jihad,”</p>
<p style="text-align: center;">She says. “You must serve my master.</p>
<p style="text-align: center;">Then you will see the face of God.</p>
<p style="text-align: center;">But never dare to ask for</p><br/>
<p style="text-align: center;"><em>Me</em> again.” He concurs</p>
<p style="text-align: center;">And serves … and forty years flash by Like a bucket of buttered popcorn</p>
<p style="text-align: center;">Before he presumes to ask why—?</p><br/>
<p style="text-align: center;">To what end had he obeyed?</p>
<p style="text-align: center;">His severe imam keeps prating,</p>
<p style="text-align: center;">“Patience! You shall be shown one day What is revealed from waiting.”</p><br/>
<p style="text-align: center;">Fed up, he leaves his master. Luckless, hungry and sleepless since,</p>
<p style="text-align: center;">Homeless by the campfire, fasting At prayer, he conjures the jinn</p><br/>
<p style="text-align: center;">Or his muse to return.</p>
<p style="text-align: center;">But it’s Iblissa in the fire,</p>
<p style="text-align: center;">Her dance in the flaming burka: “Now what is it you desire?”</p><br/>
<p style="text-align: center;">“Like a drunken ant I want to hunt the elephant.</p>
<p style="text-align: center;">With arrows of water I aim To put out the sun’s flame.</p><br/>
<p style="text-align: center;">“Like once the wife of Lot, I want to turn my gaze by half</p>
<p style="text-align: center;">On the forbidden face of God.</p>
<p style="text-align: center;">I want one good last laugh.”</p>
<p style="text-indent:0em; padding-top:250px;">Note: <em>The Tongue of the Invisible</em> (l. 11) and the 17<sup>th</sup> quatrain adapted from Hafiz, 14<sup>th</sup> c. Sufi mystic.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch007.vue?46fb5f96